/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  error: isDev ? (...args) => console.error(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
};

export default logger;
